export const determineSortColumn = (
  displayType: string,
  sort: { value: string; label: string }
) => {
  if (displayType === "baseWine") {
    switch (sort.value) {
      case "default":
        return "wines.id";
      case "vintage":
        return "wine_vintages.vintage";
      case "wine_name":
        return "wine_name";
      case "score":
        return "wines.score";
      case "author":
        return "wines.author";
      case "drinking_window_begin":
        return "wines.drinking_window_begin";
      case "release_date":
        return "wines.release_date";
      case "review_date":
        return "wines.review_date";
      default:
        return "wine_vintages.vintage";
    }
  } else {
    switch (sort.value) {
      case "default":
        return "id";
      case "vintage":
        return "vintage";
      case "wine_name":
        return "wine_name";
      case "score":
        return "score";
      case "author":
        return "author";
      case "drinking_window_begin":
        return "drinking_window_begin";
      case "release_date":
        return "release_date";
      case "review_date":
        return "review_date";
      default:
        return "";
    }
  }
};

export const getSortOptions = (articleId: string) => {
  return [
    ...(articleId ? [{ label: "Sort by default", value: "default" }] : []),
    {
      label: "Sort by Vintage",
      value: "vintage",
    },
    {
      label: "Sort by Name",
      value: "wine_name",
    },
    {
      label: "Sort by Score",
      value: "score",
    },
    {
      label: "Sort by Author",
      value: "author",
    },
    {
      label: "Sort by Drinking Window",
      value: "drinking_window_begin",
    },
    {
      label: "Sort by Review Date",
      value: "review_date",
    },
  ];
};

export const generateMetaDescription = (producerName: string): string => {
  return `Explore the wines of ${producerName} on Vinous. Discover tasting notes, reviews, and detailed information about their wine offerings.`;
};
